























































































import { Vue, Component } from 'vue-property-decorator';
import XGplayer from '@/components/XGplayer.vue';
import { detail } from '../api';
import { Icon, Toast, Swipe, SwipeItem, Lazyload, ImagePreview } from 'vant';
Vue.use(Icon)
  .use(Toast)
  .use(Swipe)
  .use(SwipeItem)
  .use(Lazyload);
@Component({
  components: {
    XGplayer,
  },
})
export default class Detail extends Vue {
  detailDate: any = {};
  showVideo: boolean = true;
  async mounted() {
    const res: any = await detail(this.$route.query.id as string);
    this.detailDate = res.data;
  }
  getImg(imageList: any, index: number) {
    const scroll =
      document.documentElement.scrollTop || document.body.scrollTop;
    ImagePreview({
      images: imageList, // 预览图片的那个数组
      showIndex: true,
      loop: false,
      startPosition: index, // 指明预览第几张图
      onClose() {
        document.documentElement.scrollTop = scroll;
        document.body.scrollTop = scroll;
      },
    });
  }
  goback() {
    const scrollTop = this.$route.query.scrollTop;
    this.$router.push(
      `home?scrollTop=${scrollTop}&type=${this.detailDate.workType}`,
    );
  }
  async turnPage(id: string) {
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
    });
    this.showVideo = false;
    const ret = await detail(id);
    if (ret.data) {
      this.detailDate = ret.data;
      this.showVideo = true;
    } else {
      this.showVideo = true;
      Toast.fail({
        message: '没有数据了',
        duration: 0,
      });
      setTimeout(() => {
        Toast.clear();
      }, 1000);
    }
  }
}
